import React, {useState} from 'react'
import SubHeader from '../general/SubHeader'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loading from '../general/Loading.js';

const AdminLogin = () => {
                const [formData, setFormData] = useState({
                  mobile: '',
                  pass: '',
                })
    
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent page reload

    setLoading(true);
    try {
      const response = await fetch('https://api.tradeintell.com/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      console.log(data);
      if (response.ok) {
            setLoading(false);
                if (data[0].id == 1) {
          localStorage.setItem('userData', JSON.stringify(data[0]));
          toast.success('Login Successful');
          navigate('/');
          window.location.reload();
        }
         else {
            setLoading(false);
          toast.error(data.message);
        }
    }
      else {
          setLoading(false);
                    toast.error(data.message === 'Account does not exists. Signup first.' 
    ? 'Invalid Credentials.' : data.message);
      }
    } catch (error) {
          setLoading(false);
      console.error('Error:', error);
    }
  };



  return (
    <>
    <SubHeader message='Admin Login' />

<section className='my-5'>
    <div className='container '>

<div className='col-lg-8 col-12 my-2 mx-auto'>
<div className='bg-light rounded-4 p-5'>

<form class="row g-3" onSubmit={handleSubmit}>
  <div class="col-12">
    <input type="tel" class="contact-control" id="inputMobile4" name='mobile' maxLength='10' onChange={handleChange} value={formData.mobile} placeholder='Mobile Number' />
  </div>
  <div class="col-12">
    <input type="password" class="contact-control" id="inputPassword4" name='pass' onChange={handleChange} value={formData.pass} placeholder='Your Password' />
  </div>


  <div class="col-12 mt-5">
    <button type="submit" class="about-btn">Login Now</button>
  </div>
</form>

</div>
</div>

    </div>
</section>

                      {loading && <Loading setLoading={setLoading} />}


    </>
  )
}

export default AdminLogin